import React from "react";
import { motion } from "framer-motion";
import { Heart, Wind, Sprout, Users, Sparkles, Compass, Star, Cog, HandHeart, Flame } from "lucide-react";
import { HOME } from "@/constants/testIds";

export const ICONS = {
  heart: Heart, wind: Wind, sprout: Sprout, users: Users, sparkles: Sparkles,
  compass: Compass, star: Star, cog: Cog, hands: HandHeart, flame: Flame,
};

export default function Needs({ needs = [], onBook }) {
  return (
    <section id="needs" className="py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <div className="eyebrow">For your unique needs</div>
          <h2 className="font-serif-ev mt-4 text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight">
            Wherever you are, there's a path for you.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {needs.map((n, i) => {
            const Icon = ICONS[n.icon] || Sparkles;
            return (
              <motion.article
                key={n.id}
                data-testid={HOME.needCard(i)}
                initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.03 }}
                className="ev-card p-6 md:p-8 smooth-hover"
              >
                <div className="ev-icon-square">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="font-serif-ev text-2xl md:text-3xl mt-6 leading-tight">{n.title}</h3>
                <p className="mt-3 text-[15px] md:text-base" style={{ color: "var(--ev-muted)" }}>{n.description}</p>
              </motion.article>
            );
          })}
        </div>

        <div className="mt-10 flex flex-col items-center gap-2">
          <button data-testid={HOME.needsBookBtn} onClick={onBook} className="ev-btn ev-btn-primary">
            Book a free session
          </button>
          <div className="text-sm" style={{ color: "var(--ev-muted)" }}>No credit card required</div>
        </div>
      </div>
    </section>
  );
}
